import React from "react";

import DOMPurify from "dompurify";
import styles from './ExclusionesList.module.css';

const ExclusionesList = ({ exclusiones }) => {
    return (
        <React.Fragment>
            <div className={styles.exclusiones__list}>
                <ul>
                    {exclusiones && exclusiones.length && exclusiones.map((item, index) => {
                        return <React.Fragment key={index}>
                            <li dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.nombreExlusion) }}></li>
                            <br />
                        </React.Fragment>;
                    })}
                </ul>
            </div>
        </React.Fragment>
    );
}

export default ExclusionesList;